// extracted by mini-css-extract-plugin
var _1 = "ScrollContainer-moduleScrollContainer__LHyVB";
var _2 = "ScrollContainer-modulehorizontal__UGDUd";
var _3 = "ScrollContainer-modulevertical__s9nf3";
export { _1 as "ScrollContainer", _2 as "horizontal", _3 as "vertical" }
